import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { CoreService } from '@app/core/services';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-work-menu',
  template: `
    <div style="max-height: 30vh; overflow-x: hidden; overflow-y: auto;">
      <app-scheduled-campaigns></app-scheduled-campaigns>
    </div>
    <app-management-panel></app-management-panel>
    <app-dial-pad></app-dial-pad>
    <lib-chat [campaignId]="campaignId$ | async"></lib-chat>
  `,
  styles: [``],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkMenuComponent {
  @HostBinding('class') class = 'd-flex flex-column flex-grow-1';
  campaignId$ = this.coreSvc.campaignId$.pipe(distinctUntilChanged());
  constructor(private coreSvc: CoreService) {}
}
